import angular from 'angular';

const name = 'mmsMinlength';
export const MinlengthDirective = {
    name,
    directive: directive
};

function directive() {
    'ngInject';
    return {
        restrict: 'A',
        scope: true,
        require: 'ngModel',
        link: function($scope, $element, $attrs, ngModel) {
            let minlength = 0;
            $attrs.$observe(name, function(value) {
                minlength = parseInt(value, 10);
                ngModel.$validate();
            });
            ngModel.$validators[name] = function(modelValue, viewValue='') {
                return viewValue.length >= minlength;
            };
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/directives/minlength.directive.js